/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Prop_Show_PhotoInputs */

const cs_builder_prop_show_photo = /** @type {(inputs: Builder_Prop_Show_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zobrazit foto`)
};

const en_builder_prop_show_photo = /** @type {(inputs: Builder_Prop_Show_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show photo`)
};

/**
* | output |
* | --- |
* | "Show photo" |
*
* @param {Builder_Prop_Show_PhotoInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_prop_show_photo = /** @type {((inputs?: Builder_Prop_Show_PhotoInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Prop_Show_PhotoInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_prop_show_photo(inputs)
	return cs_builder_prop_show_photo(inputs)
});